<template>
<div class="layout--full-page">
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/research.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Đăng nhập</h4>
                  <p>hpquet phiên bản mới - hp@2020.</p>
                </div>

                <form v-on:submit.prevent="preventSubmit()">
                  <vs-input
                      name="user"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Tên tài khoản"
                      v-model="user"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Mật khẩu"
                      v-model="password"
                      class="w-full mt-6" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-alert :active="loginError" color="danger" icon="new_releases" >
                      <span>Sai thông tin đăng nhập</span>
                    </vs-alert>
                  </div>
                 
                  <vs-button button="submit" class="float-right mb-5" @click="login">Đăng nhập</vs-button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default{
  data() {
    return {
      user: "",
      password: "",
      checkbox_remember_me: false,
      loginError: false
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  watch:{
    currentUser: function(u){
      this.$acl.change(u.permissions);
      this.$router.push({ name: 'home' });
    }
  },
  methods: {
    login () {
      let vm = this;
      vm.loginError = false;
      // Loading
      vm.$vs.loading();

      vm.$store
        .dispatch('login', {
          name: vm.user,
          password: vm.password,
        })
        .then((res) => {
          vm.$vs.loading.close();
        })
        .catch(err => {
          vm.loginError = true;
          vm.$vs.loading.close();
        })
    },
    preventSubmit: function(){
      return false;
    },
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
